var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU03 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 345.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-861.00, 0.00)",
    id: "U3_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M865.42,252.46 C865.52,250.96 867.71,233.24 868.62,226.47 C870.31,215.05 873.00,204.18 876.85,195.83 C880.74,187.47 889.93,173.25 895.75,165.98 C900.29,160.54 910.39,149.35 915.94,143.58 C927.73,131.84 955.01,107.70 967.46,97.97 C973.51,93.45 986.22,84.64 990.60,81.90 C997.35,77.71 1014.18,70.35 1021.42,68.59 C1025.03,67.73 1031.79,66.92 1034.97,66.95 C1038.11,67.01 1044.72,67.95 1048.15,68.83 C1055.02,70.64 1070.34,77.83 1076.45,81.98 C1082.39,86.07 1091.55,93.26 1098.34,99.05 C1109.87,109.43 1134.17,134.78 1144.73,147.06 C1149.77,153.13 1162.06,168.82 1163.47,170.89 C1167.81,177.29 1177.91,195.19 1181.54,202.91 C1185.04,210.44 1190.43,225.37 1192.77,232.38 C1194.87,239.09 1199.27,255.15 1199.72,257.49 C1201.05,264.47 1202.05,279.25 1201.60,285.16 C1201.31,288.39 1199.51,294.07 1197.65,297.51 C1193.81,304.46 1182.91,316.70 1175.82,323.14 C1165.71,331.89 1139.13,351.98 1123.71,362.85 C1108.84,372.94 1075.93,393.74 1070.83,396.45 C1061.39,401.43 1043.54,408.78 1036.86,410.42 C1033.55,411.21 1027.64,411.91 1024.53,411.86 C1018.30,411.74 1004.53,408.17 998.45,405.13 C992.32,402.04 980.22,394.19 973.72,389.08 C973.59,388.98 924.20,348.22 921.91,346.30 C915.10,340.74 901.87,330.50 895.48,325.81 C889.31,321.24 879.68,312.33 875.32,307.17 C873.26,304.68 869.58,298.02 868.28,294.65 C866.98,291.22 865.53,284.48 865.29,280.72 C864.97,275.40 865.29,254.41 865.42,252.46 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU03, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-03.e6731fa7.svg";
export { ForwardRef as ReactComponent };